import React, { useState } from "react";
import { openDemoModal } from "../utils/demoModal";

import logoDark from "../../interviewAI/assets/Talenttalklogo.png";
import thankYouIllustration from "../assets/ModalIcon/thankyou-illustration.svg";
import topLeftShape from "../assets/ModalIcon/hero-shape-top-left.svg";
import bottomRightShape from "../assets/ModalIcon/hero-shape-bottom-right.svg";
import homeIcon from "../assets/ModalIcon/home.svg";
import mailIcon from "../assets/ModalIcon/mail.svg";
import walkthroughIcon from "../assets/ModalIcon/personalized-walkthrough.svg";
import expertsIcon from "../assets/ModalIcon/talk-to-product-experts.svg";
import useCasesIcon from "../assets/ModalIcon/explore-use-cases.svg";
import hiringIcon from "../assets/ModalIcon/start-hiring-smarter.svg";
import interFont from "../assets/ModalIcon/inter-variable.woff2";
import kalam400 from "../assets/ModalIcon/kalam-400.woff2";
import kalam700 from "../assets/ModalIcon/kalam-700.woff2";

const DEMO_THANKYOU_CSS = `
@font-face{font-family:TTThankYouInter;src:url("${interFont}") format("woff2");font-style:normal;font-weight:100 900;font-display:swap}
@font-face{font-family:TTThankYouKalam;src:url("${kalam400}") format("woff2");font-style:normal;font-weight:400;font-display:swap}
@font-face{font-family:TTThankYouKalam;src:url("${kalam700}") format("woff2");font-style:normal;font-weight:700;font-display:swap}
.tt-thankyou-page{--ty-purple:#6A1B9A;--ty-ink:#0B1F44;--ty-muted:#4B5563;--ty-lavender:#F5F8FF;--ty-hero:#F9FBFF;--ty-illu-w:min(648px,calc((50vw - 10px) / .6375));color:var(--ty-ink);font-family:TTThankYouInter,Inter,Arial,sans-serif;min-height:100vh;padding-top:88px;background:#fff;overflow:hidden}
.tt-thankyou-page *{box-sizing:border-box}
.tt-thankyou-page a{color:inherit;text-decoration:none}
.tt-thankyou-page ul{list-style:none;margin:0;padding:0}
.tt-thankyou-page button{font-family:inherit}
.tt-ty-visually-hidden{position:absolute!important;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border:0}

/* ---------- Header ---------- */
.tt-ty-header{display:none}
.tt-ty-header-inner{width:min(1240px,calc(100% - 64px));margin:0 auto;display:flex;align-items:center;gap:34px}
.tt-ty-logo{display:block;flex:0 0 auto;line-height:0}
.tt-ty-logo img{display:block;width:268px;height:auto;max-width:100%}
.tt-ty-nav{display:flex;align-items:center;margin-left:auto}
.tt-ty-nav-list{display:flex;align-items:center;gap:clamp(8px,1.4vw,22px)}
.tt-ty-nav-link{display:inline-flex;align-items:center;gap:8px;font-size:14px;font-weight:550;color:var(--ty-ink);white-space:nowrap;padding:8px 10px;border-radius:999px}
.tt-ty-nav-link--pill{background:var(--ty-lavender);padding:8px 14px}
.tt-ty-nav-chevron{flex:0 0 auto}
.tt-ty-nav-mobile-actions{display:none}
.tt-ty-header-actions{display:flex;align-items:center;gap:13px}
.tt-ty-search{display:grid;place-items:center;width:40px;height:40px;border:0;background:transparent;color:var(--ty-ink);cursor:pointer;border-radius:50%}
.tt-ty-btn{display:inline-flex;align-items:center;justify-content:center;font-size:13px;font-weight:650;white-space:nowrap;border-radius:8px;padding:12px 17px}
.tt-ty-btn--outline-sm{border:1px solid #C9D3E2;color:var(--ty-ink)}
.tt-ty-btn--primary-sm{background:var(--ty-purple);color:#fff!important}
.tt-ty-nav-toggle{display:none;flex-direction:column;justify-content:center;gap:5px;width:40px;height:40px;padding:0 9px;border:0;background:transparent;cursor:pointer}
.tt-ty-nav-toggle-bar{display:block;height:2px;width:100%;background:var(--ty-ink);border-radius:2px;transition:transform .2s ease,opacity .2s ease}
.tt-ty-nav-toggle.is-open .tt-ty-nav-toggle-bar:nth-child(1){transform:translateY(7px) rotate(45deg)}
.tt-ty-nav-toggle.is-open .tt-ty-nav-toggle-bar:nth-child(2){opacity:0}
.tt-ty-nav-toggle.is-open .tt-ty-nav-toggle-bar:nth-child(3){transform:translateY(-7px) rotate(-45deg)}

/* ---------- Hero ---------- */
.tt-ty-hero{position:relative;isolation:isolate;padding:30px 0 64px;background:var(--ty-hero);overflow:hidden;box-shadow:0 0 4px rgba(0,0,0,.25)}
.tt-ty-shape{position:absolute;z-index:-1;pointer-events:none;user-select:none}
.tt-ty-shape-tl{left:0;top:0;width:587px}
.tt-ty-shape-br{right:0;bottom:0;width:339px}
.tt-ty-container{position:relative;width:min(1290px,calc(100% - 150px));margin:0 auto;display:flex;flex-direction:column;align-items:center;text-align:center}
.tt-ty-visual{position:relative;width:100%;height:calc(var(--ty-illu-w) * 310 / 648)}
.tt-ty-illustration{position:absolute;display:block;top:0;left:calc(50% - var(--ty-illu-w) * 234.9 / 648);width:var(--ty-illu-w);max-width:none;height:auto;transform:none}

/* handwritten tagline: 4 stacked lines, tilted, to the right of the paper plane */
.tt-ty-tagline{position:absolute;top:111px;left:calc(50% + 448px);margin:0;text-align:left;color:var(--ty-purple);font-family:TTThankYouKalam,cursive;font-weight:400;font-size:26px;line-height:31px;transform:rotate(-9deg);transform-origin:left top;white-space:nowrap}
.tt-ty-tagline-pair,.tt-ty-tagline-line{display:block}
.tt-ty-tagline-swoosh{width:72px;height:44px;margin:-4px 0 0 30px;overflow:visible;transform:rotate(9deg)}

.tt-ty-message{width:100%;max-width:720px;margin:0 auto;padding:0}
.tt-ty-message h1{font-size:100px;line-height:1;letter-spacing:-.005em;font-weight:800;margin:22px 0 0;color:var(--ty-ink)}
.tt-ty-message h1 .tt-ty-accent{color:var(--ty-purple);background:linear-gradient(125deg,#00AEEF 0%,#3A5BC7 45%,#6A1B9A 90%);-webkit-background-clip:text;background-clip:text;-webkit-text-fill-color:transparent}
.tt-ty-subtitle{font-size:32px;font-weight:600;line-height:1.2;letter-spacing:.002em;margin:14px 0 0;color:var(--ty-muted)}
.tt-ty-description{font-size:18px;line-height:22px;color:var(--ty-muted);max-width:580px;margin:19px auto 0}
.tt-ty-ctas{display:flex;justify-content:center;gap:28px;flex-wrap:wrap;margin-top:32px}
.tt-ty-cta{width:261px;height:63px;display:inline-flex;align-items:center;justify-content:center;gap:24px;padding:0;border-radius:4px;font-size:17px;font-weight:600;transition:background-color .2s ease,color .2s ease,border-color .2s ease}
.tt-ty-cta img{width:26px;height:26px;object-fit:contain}
.tt-ty-cta-primary{background:linear-gradient(125deg,#00AEEF 0%,#3A5BC7 45%,#6A1B9A 90%);color:#fff!important}
.tt-ty-cta-primary img{filter:brightness(0) invert(1)}
.tt-ty-cta-outline{background:#fff;border:1px solid var(--ty-purple);color:var(--ty-purple)!important}

/* next steps card */
.tt-ty-cta-primary:hover{background:linear-gradient(125deg,#00AEEF 0%,#3A4AB0 40%,#4A1270 85%)}
.tt-ty-cta-outline{gap:20px}
.tt-ty-cta-outline:hover{background:var(--ty-lavender)}

/* next steps */
.tt-ty-next-steps{width:min(100%,1168px);display:grid;grid-template-columns:repeat(4,minmax(0,1fr));margin:33px 0 0!important;padding:0!important;background:var(--ty-lavender);border:1px solid #fdfdfe;border-radius:8px}
.tt-ty-step{position:relative;min-width:0;padding:35px 12px 25px;text-align:center}
.tt-ty-step:not(:last-child)::after{content:"";position:absolute;right:13px;top:25px;height:161px;width:1px;background:#E3E7EE}
.tt-ty-step img{display:block;width:70px;height:70px;object-fit:contain;margin:0 auto}
.tt-ty-step h2{font-size:18px;line-height:22px;font-weight:600;margin:30px 0 0;color:var(--ty-ink)}
.tt-ty-step p{font-size:16px;line-height:19px;color:var(--ty-muted);margin:11px auto 0;max-width:232px}

/* ---------- Responsive ---------- */
@media(max-width:1280px){.tt-ty-container{width:min(calc(100% - 80px),1290px)}.tt-ty-tagline{left:auto;right:0}}
@media(max-width:1050px){.tt-ty-header-inner{width:calc(100% - 40px);gap:20px}.tt-ty-logo img{width:210px}.tt-ty-header-actions{gap:8px}.tt-ty-btn{padding:11px 12px}}
@media(max-width:1000px){
  .tt-ty-tagline{position:relative;top:auto;right:auto;margin:4px 0 0;padding-right:56px;font-size:23px;line-height:28px;text-align:center;transform:rotate(-4deg);transform-origin:50% 50%}
  .tt-ty-tagline-line{display:inline}
  .tt-ty-tagline-swoosh{position:absolute;right:0;bottom:-14px;width:58px;height:36px;margin:0;transform:none}
  .tt-ty-message h1{margin-top:18px}
  .tt-ty-next-steps{grid-template-columns:repeat(2,minmax(0,1fr));gap:0}
  .tt-ty-step{padding:32px 16px 28px}
  .tt-ty-step:not(:last-child)::after{display:none}
  .tt-ty-step:nth-child(odd)::after{display:block;top:24px;right:0;height:calc(100% - 48px)}
  .tt-ty-step:nth-child(n + 3)::before{content:"";position:absolute;top:0;left:24px;right:24px;height:1px;background:#E3E7EE}
}
@media(max-width:860px){
  .tt-ty-nav-toggle{display:flex}
  .tt-ty-header-login,.tt-ty-header-demo{display:none}
  .tt-ty-nav{display:none;position:absolute;left:0;right:0;top:100%;margin:0;flex-direction:column;align-items:stretch;gap:14px;background:#fff;padding:16px 20px 22px;border-bottom:1px solid #f0eff7;box-shadow:0 14px 28px #25114b12}
  .tt-ty-nav.is-open{display:flex}
  .tt-ty-nav-list{flex-direction:column;align-items:stretch;gap:4px}
  .tt-ty-nav-link{padding:12px 10px}
  .tt-ty-nav-link--pill{align-self:flex-start}
  .tt-ty-nav-mobile-actions{display:flex;gap:10px}
}
@media(max-width:760px){.tt-thankyou-page{padding-top:72px}.tt-ty-header-inner{width:calc(100% - 36px)}.tt-ty-logo img{width:190px}.tt-ty-container{width:calc(100% - 48px)}.tt-ty-hero{padding:24px 0 48px}.tt-ty-shape-tl{width:min(587px,62vw)}.tt-ty-shape-br{width:min(339px,40vw)}.tt-ty-message h1{font-size:clamp(54px,14.5vw,100px)}.tt-ty-subtitle{font-size:clamp(21px,5.6vw,32px);margin-top:12px}.tt-ty-description{margin-top:16px}.tt-ty-ctas{margin-top:28px}}
@media(max-width:600px){
  .tt-ty-ctas{flex-direction:column;align-items:center;gap:16px;width:100%}
  .tt-ty-cta{width:min(100%,300px);height:58px;font-size:16px}
  .tt-ty-step h2{font-size:16px}
  .tt-ty-step p{font-size:14px}
}
@media(max-width:480px){.tt-ty-next-steps{grid-template-columns:1fr}.tt-ty-step:nth-child(odd)::after{display:none}.tt-ty-step:not(:first-child)::before{content:"";position:absolute;top:0;left:24px;right:24px;height:1px;background:#E3E7EE}.tt-ty-tagline{font-size:17px}.tt-ty-logo img{width:160px}}
@media(max-width:400px){.tt-ty-subtitle{font-size:16px;letter-spacing:0;white-space:nowrap}}
`;

const nextSteps = [
  {
    icon: walkthroughIcon,
    title: "Personalized Walkthrough",
    text: "See how Viriqo Hires fits your hiring needs",
  },
  {
    icon: expertsIcon,
    title: "Talk to Product Experts",
    text: "Get answers to your questions",
  },
  {
    icon: useCasesIcon,
    title: "Explore Use Cases",
    text: "Learn how teams like yours are using Viriqo Hires",
  },
  {
    icon: hiringIcon,
    title: "Start Hiring Smarter",
    text: "Move faster with AI-powered interviews",
  },
];

export default function DemoThankYou() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <div className="tt-thankyou-page">
      <style>{DEMO_THANKYOU_CSS}</style>

      {/* ============ Header ============ */}
      <header className="tt-ty-header" id="top">
        <div className="tt-ty-header-inner">
          <a href="/" className="tt-ty-logo" aria-label="TalentTalks home">
            <img src={logoDark} alt="TalentTalks" width="268" height="37" />
          </a>

          <nav
            className={`tt-ty-nav${menuOpen ? " is-open" : ""}`}
            id="tt-ty-main-nav"
            aria-label="Primary"
          >
            <ul className="tt-ty-nav-list">
              <li>
                <a href="/product" className="tt-ty-nav-link tt-ty-nav-link--pill">
                  Product
                  <svg className="tt-ty-nav-chevron" width="8" height="5" viewBox="0 0 8 5" fill="none" aria-hidden="true">
                    <path d="M1 1l3 3 3-3" stroke="currentColor" strokeWidth="1.1" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </a>
              </li>
              <li><a href="/features" className="tt-ty-nav-link">Features</a></li>
              <li><a href="/solutions" className="tt-ty-nav-link">Solutions</a></li>
              <li><a href="/resources" className="tt-ty-nav-link">Resources</a></li>
              <li><a href="/about" className="tt-ty-nav-link">About Us</a></li>
            </ul>

            {/* Actions duplicated inside the mobile menu panel */}
            <div className="tt-ty-nav-mobile-actions">
              <a href="/login" className="tt-ty-btn tt-ty-btn--outline-sm">Login</a>
              <a href="#request-a-demo" onClick={(event) => { event.preventDefault(); openDemoModal(); }} className="tt-ty-btn tt-ty-btn--primary-sm">Request a Demo</a>
            </div>
          </nav>

          <div className="tt-ty-header-actions">
            <button type="button" className="tt-ty-search" aria-label="Search">
              <svg width="22" height="22" viewBox="0 0 22 22" fill="none" aria-hidden="true">
                <circle cx="9.6" cy="9.6" r="8.35" stroke="currentColor" strokeWidth="1.7" />
                <path d="M15.8 15.8l5 5" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
              </svg>
            </button>
            <a href="/login" className="tt-ty-btn tt-ty-btn--outline-sm tt-ty-header-login">Login</a>
            <a href="#request-a-demo" onClick={(event) => { event.preventDefault(); openDemoModal(); }} className="tt-ty-btn tt-ty-btn--primary-sm tt-ty-header-demo">Request a Demo</a>
            <button
              type="button"
              className={`tt-ty-nav-toggle${menuOpen ? " is-open" : ""}`}
              aria-label={menuOpen ? "Close menu" : "Open menu"}
              aria-controls="tt-ty-main-nav"
              aria-expanded={menuOpen}
              onClick={() => setMenuOpen((open) => !open)}
            >
              <span className="tt-ty-nav-toggle-bar" />
              <span className="tt-ty-nav-toggle-bar" />
              <span className="tt-ty-nav-toggle-bar" />
            </button>
          </div>
        </div>
      </header>

      <main>
        {/* ============ Thank You Hero ============ */}
        <section className="tt-ty-hero" aria-labelledby="tt-ty-title">
          <img className="tt-ty-shape tt-ty-shape-tl" src={topLeftShape} alt="" aria-hidden="true" />
          <img className="tt-ty-shape tt-ty-shape-br" src={bottomRightShape} alt="" aria-hidden="true" />

          <div className="tt-ty-container">
            <div className="tt-ty-visual">
              <img
                className="tt-ty-illustration"
                src={thankYouIllustration}
                alt="Envelope with a confirmation checkmark and a paper plane"
                width="648"
                height="310"
              />
            </div>

            {/* Handwritten tagline */}
            <p className="tt-ty-tagline" aria-label="Smarter Interviews. Brighter Teams.">
              <span className="tt-ty-tagline-pair">
                <span className="tt-ty-tagline-line">Smarter</span>{" "}
                <span className="tt-ty-tagline-line">Interviews.</span>
              </span>
              <span className="tt-ty-tagline-pair">
                <span className="tt-ty-tagline-line">Brighter</span>{" "}
                <span className="tt-ty-tagline-line">Teams.</span>
              </span>
              <svg className="tt-ty-tagline-swoosh" width="72" height="44" viewBox="0 0 72 44" fill="none" aria-hidden="true">
                <path d="M2 42.5C22 28 44 12 62 4.5c6-2.3 9.5-.8 8 2.6C67.5 12 49 22 30 32" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </p>

            <div className="tt-ty-message">
              <h1 id="tt-ty-title">Thank <span className="tt-ty-accent">You!</span></h1>
              <p className="tt-ty-subtitle">Your request has been received.</p>
              <p className="tt-ty-description">
                Our team will review your details and get in touch with you shortly to schedule your personalized demo.
              </p>

              <div className="tt-ty-ctas">
                <a href="/" className="tt-ty-cta tt-ty-cta-primary">
                  <img src={homeIcon} alt="" width="26" height="26" aria-hidden="true" />
                  <span>Back to Homepage</span>
                </a>
                <a href="/contact" className="tt-ty-cta tt-ty-cta-outline">
                  <img src={mailIcon} alt="" width="26" height="26" aria-hidden="true" />
                  <span>Contact Us</span>
                </a>
              </div>
            </div>

            {/* Next steps */}
            <ul className="tt-ty-next-steps">
              {nextSteps.map((step) => (
                <li className="tt-ty-step" key={step.title}>
                  <img src={step.icon} alt="" width="70" height="70" />
                  <h2>{step.title}</h2>
                  <p>{step.text}</p>
                </li>
              ))}
            </ul>
          </div>
        </section>
      </main>

    </div>
  );
}
